import type { Components } from '@mui/material/styles';

export default function MuiSwipeableDrawer(): Components['MuiSwipeableDrawer'] {
  return {};
}
